export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-accent-500">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[700px] mx-auto text-center">
          <p className="text-xs md:text-sm font-medium text-background-50/80 uppercase tracking-wide mb-2">联系我们</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">联系我们</h2>
          <p className="mt-3 text-sm md:text-base text-background-50/80 leading-relaxed">
            如有影视资源推荐、内容合作、版权问题或使用反馈，欢迎通过以下方式与我们取得联系。糖心视频团队将尽快回复您的每一条消息。
          </p>
          <div className="mt-6 inline-flex flex-col sm:flex-row items-center gap-3">
            <a
              href="mailto:contact@tangxin.video"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 text-accent-600 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg"></i>
              发送邮件
            </a>
            <span className="text-sm text-background-50/70">
              客服邮箱：contact@tangxin.video
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}